<div class="container-fluid" >
  <div class="d-flex align-items-center justify-content-between flex-wrap" *ngIf="template">
    <div class="start d-flex align-items-center flex-wrap">
      <button nbButton size="tiny" status="basic" class="btn" [routerLink]="['/pages/template/'+template?.id+'/edit']">
        <nb-icon icon="arrow-back-outline" pack="eva"></nb-icon>
      </button>
      <div>
        <h1 class="my-0">{{ template?.name | txtTranslate }}</h1>
      </div>
    </div>
    <div class=" end">
      <template-menu [template]="template"></template-menu>
    </div>
  </div>
  <div class="d-flex align-items-center justify-content-between flex-wrap" *ngIf="!template">
    <div class="start d-flex align-items-center flex-wrap">
      <button nbButton size="tiny" status="basic" class="btn" [routerLink]="['/pages/game/'+game?.id+'/edit-missions']">
        <nb-icon icon="arrow-back-outline" pack="eva"></nb-icon>
      </button>
      <div>
        <h1 class="my-0">{{ game?.name | txtTranslate }}</h1>
      </div>
    </div>
    <div class=" end">
      <game-menu [game]="game"></game-menu>
    </div>
  </div>
</div>

<div class="accordion-container col">
  <nb-card size="giant" accent="info">
    <nb-card-header>
      <div class="d-flex align-items-center justify-content-between w-100">
        <span>Roles</span>
      </div>
      <button nbButton size="tiny" status="basic" class="btn ml-3" *ngIf="template" (click)="applyChanges()">
        <nb-icon icon="code-download-outline" pack="eva"></nb-icon>Apply changes to games
      </button>
    </nb-card-header>
    <nb-card-body style="padding-top: 0 !important; padding-left: 0 !important;">
      <table class="table table-hover">
        <thead>
          <tr>
            <td>Order</td>
            <td>Icon</td>
            <td>Label</td>
            <td class="text-right"><button type="button" class="btn btn-success" (click)="editRole(null)">Add new</button></td>
          </tr>
        </thead>
        <tbody>
        <tbody>
          <ng-template ngFor let-role="$implicit" let-i="index" [ngForOf]="roles">
            <tr>
              <td>{{role.orderNum}}</td>
              <td>
                <img [src]="role | objectImage" style="width:40px;height:auto;">
              </td>
              <td >{{ role.labels | txtTranslate }}</td>
              <td class="text-right">
                <button nbButton class="btn-rounded ml-3" status="info" [disabled]="roles.length === (i+1)" outline (click)="changePosition(i, i+1)">
                  <nb-icon icon="arrow-ios-downward-outline"></nb-icon>
                </button>
                <button nbButton class="btn-rounded ml-3" status="info" [disabled]="i === 0" outline (click)="changePosition(i, i-1)">
                  <nb-icon icon="arrow-ios-upward-outline"></nb-icon>
                </button>
                <button class="btn btn-rounded btn-xs btn-info btn-inverse ml-3"
                  (click)="editRole(role)">EDIT</button>
                <button class="btn btn-rounded btn-xs btn-danger btn-inverse ml-3"
                  (click)="deleteRole(role)"><nb-icon icon="trash-2-outline"></nb-icon></button>
              </td>
            </tr>
          </ng-template>
        </tbody>
      </table>
    </nb-card-body>
  </nb-card>
</div>